import React, { useEffect } from 'react';
import api from '../api'; // tu instancia de Axios configurada

export default function Success() {
  useEffect(() => {
    api.post('/create-magic-link')
      .then(({ data }) => {
        if (data?.url) {
          window.location.href = data.url; // Redirige a Laravel logueado
        }
      })
      .catch(err => {
        console.error('Error creando magic link', err);
        window.location.href = 'https://tu-dominio-laravel.com/login';
      });
  }, []);

  return (
    <div className="success-container">
      <div className="loader"></div>
      <h1 className="fade-text">¡Gracias por suscribirte!</h1>
      <p className="fade-text">Estamos activando tu cuenta y redirigiéndote al campus...</p>

      <style>{`
        .success-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 80vh;
          font-family: 'Inter', sans-serif;
          text-align: center;
          padding: 1rem;
          color: #162133;
        }

        /* Loader circular */
        .loader {
          border: 6px solid #f3f3f3;
          border-top: 6px solid #e4ba16; /* color primario */
          border-radius: 50%;
          width: 60px;
          height: 60px;
          animation: spin 1s linear infinite;
          margin-bottom: 1.5rem;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Texto con fade */
        .fade-text {
          animation: fadeInOut 2.5s ease-in-out infinite;
        }

        @keyframes fadeInOut {
          0%, 100% { opacity: 0.2; }
          50% { opacity: 1; }
        }

        h1 {
          font-size: 1.8rem;
          margin-bottom: 0.5rem;
          font-weight: 700;
        }

        p {
          font-size: 1rem;
          max-width: 400px;
          line-height: 1.5;
        }
      `}</style>
    </div>
  );
}
